import Hstack from "@/components/ui/hstack";
// import Search from "@/components/ui/search";
import { KCBLogo } from "@/shared/icons";
import NavBar from "./nav-bar";
import { navbarItems } from "@/shared/constants/navBarKey";
import NotifyUser from "./notify-user";
import { ROUTERS } from "@/shared/constants/router";
import { useNavigate } from "@tanstack/react-router";
// import clsx from "clsx";
export default function Header() {
  const navigate = useNavigate();
  return (
    <Hstack py={"16px"} gap={"32px"} align={"center"} justify={"between"}>
      <KCBLogo
        className="cursor-pointer h-[60px] w-[215px]"
        onClick={() => navigate({ to: ROUTERS.HOME })}
      />
      {/* <Search
        width={"521px"}
        className={clsx(
          `[&>input:-webkit-autofill]:[-webkit-text-fill-color:white!important]`,
          `[&>input::placeholder]:!text-[#667085]`,
          "border-1 border-[#667085]"
        )}
      /> */}
      <Hstack gap={"32px"}>
        <NavBar navKey={navbarItems} />
        <NotifyUser />
      </Hstack>
    </Hstack>
  );
}
